<div class="side-nav-panel-content alerts-scroll">
    <mat-tab-group>
        <mat-tab label="Coordinator">
            <mat-accordion>
                <mat-expansion-panel
                *ngFor="let alert of coordinatorList;let i=index"
                [expanded]="alert.alertId==expandedPanel"
                (opened)="setExpandedpanel(alert)"
                (closed)="expandedPanel = alert.alertId === expandedPanel ? 0 : expandedPanel">
                    <mat-expansion-panel-header collapsedHeight="5em" expandedHeight="*">
                        <div class="side">
                            <p>{{alert.alertMsg.upperLeftTextBox === 'null' ? '' : alert.alertMsg.upperLeftTextBox}}</p>
                            <p>{{alert.alertMsg.upperRightTextBox === 'null' ? '' : alert.alertMsg.upperRightTextBox}}</p>
                        </div>
                        <div class="side">
                            <p>{{alert.alertMsg.lowerLeftTextBox === 'null' ? '' : alert.alertMsg.lowerLeftTextBox}}</p>
                            <p>{{alert.alertMsg.lowerRightTextBox === 'null' ? '' : alert.alertMsg.lowerRightTextBox}}</p>
                        </div>
                        <div class="minutesBorderBoxDiv"><div class="alertTypeBoxWrap"><div class="alertTypeBoxStyle">{{alert.alertMsg.threeLetterSign}}</div></div></div>

                    </mat-expansion-panel-header>
                    <!-- DETAILS -->
                    <p>{{alert.alertMsg.msg}}</p>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-tab>
        <mat-tab label="Driver">
            <mat-accordion>
                <mat-expansion-panel
                *ngFor="let alert of driverList;let i=index"
                [expanded]="alert.alertId==expandedPanel"
                (opened)="setExpandedpanel(alert)"
                (closed)="expandedPanel = alert.alertId === expandedPanel ? 0 : expandedPanel">
                    <mat-expansion-panel-header collapsedHeight="5em" expandedHeight="*">
                      <div class="side">
                        <p>{{alert.alertMsg.upperLeftTextBox === 'null' ? '' : alert.alertMsg.upperLeftTextBox}}</p>
                        <p>{{alert.alertMsg.upperRightTextBox === 'null' ? '' : alert.alertMsg.upperRightTextBox}}</p>
                      </div>
                      <div class="side">
                        <p>{{alert.alertMsg.lowerLeftTextBox === 'null' ? '' : alert.alertMsg.lowerLeftTextBox}}</p>
                        <p>{{alert.alertMsg.lowerRightTextBox === 'null' ? '' : alert.alertMsg.lowerRightTextBox}}</p>
                      </div>
                      <div class="minutesBorderBoxDiv"><div class="alertTypeBoxWrap"><div class="alertTypeBoxStyle">{{alert.alertMsg.threeLetterSign}}</div></div></div>
                    </mat-expansion-panel-header>
                    <!-- DETAILS -->
                    <p>{{alert.alertMsg.msg}}</p>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-tab>
    </mat-tab-group>
</div>
